import { authRoleAccess } from "auth/AuthRoleAccess";
import { lazy } from "react";

const FirstRespondentCaseView = lazy(() => import("./FirstRespondentCaseView.jsx"));
const CaseSingleCaseView = lazy(() => import("./CaseSingleCaseView.jsx"));

const FirstRespondentCaseViewRoutes = [
  {
    path: "/first-respondent-case-view",
    component: FirstRespondentCaseView,
    auth: authRoleAccess.first_respondent_case_view,
  },
  {
    path: "/first-respondent/cases/:id",
    component: CaseSingleCaseView,
    auth: authRoleAccess.first_respondent_case_view,
  },
];

export default FirstRespondentCaseViewRoutes;
